
import React, { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

import UserIcon from '@/assets/img/user-icon.svg?react';
import AccessIcon from '@/assets/img/access-icon.svg?react';

import styles from './avatar.module.scss';
import { User } from '@/hooks/identity/responseModels/user';

interface IAvatarProps {
  user: User | null | undefined;
  size: number;
  isLoading: boolean;
}

export default function Avatar({ user, size, isLoading }: IAvatarProps) {
  const initials = (user?.FirstName?.substring(0, 1) ?? '') + (user?.LastName?.substring(0, 1) ?? '');

  const imageUrl = useMemo(() => {
    return user?.AvatarUrl ?? null;
  }, [user?.AvatarUrl]);

  if (isLoading) {
    return (
      <div className="mr-10">
        <Skeleton
          circle={true}
          height={size}
          width={size}
        />
      </div>
    );
  }

  if (!user) {
    return (
      <div className={styles.accessIcon}>
        <AccessIcon />
      </div>
    );
  }

  return (
    <div className={styles.avatar}>
      <>
        {imageUrl && imageUrl.length > 0 && (
          <div
            className={styles.image}
            style={{
              backgroundImage: `url(${imageUrl})`,
              width: size,
              height: size
            }}
          />
        )}

        {!imageUrl && initials && (
          <div className={styles.initials}>
            {initials}
          </div>
        )}

        {!imageUrl && !initials && (
          <div className={styles.userIcon}>
            <UserIcon />
          </div>

        )}
      </>
    </div>
  );
}

